<template>
  <div class="weihu">
      <div class="tishiImg">
          <img src="../assets/images/weihu.png" alt="">
      </div>
      <div class="word">
         服务维护中，请稍后再试
      </div>
  </div>
</template>

<script>

export default {
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.weihu{
    background-color: #ffff;
    min-height: 100vh;
    padding-top: 8.5rem;
    .tishiImg{
        display: flex;
        justify-content: center;
        img{
            width: 35rem;
            height: 33rem;
        }
    }
    .word{
        text-align: center;
        color: #338989;
        font-size: 2.125rem;
        margin-top: 4.375rem;
        font-weight: 900;
    }
}

</style>